/*
let getTodo = remote.create({url : '/todo'})

@delay(10)
function getData(){
	getTodo()
	.then((res)=>{

	})
}

getData = delay(getData,2,this)

getData(1)
 */

export default function delay<T extends (...args : any[])=> void>(func : T,secondtime=1,context? : any) : (...args : Parameters<T>)=>void {
	let handle : number | null = null
	return function (this : unknown,...args : any[]) {
		if(handle){
			clearTimeout(handle)
			handle = null
		}
		handle = window.setTimeout(()=>{
			func.apply(context || this,args)
			handle = null
		}, secondtime * 1000)
    }
}